module.exports = __webpack_public_path__ + "site/img/42.d18b66cf.jpg";